import { render } from "./ScoreCarousel.vue?vue&type=template&id=4dee4954&scoped=true&ts=true"
import script from "./ScoreCarousel.vue?vue&type=script&lang=ts"
export * from "./ScoreCarousel.vue?vue&type=script&lang=ts"

import "./ScoreCarousel.vue?vue&type=style&index=0&id=4dee4954&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dee4954"]])

export default __exports__